import script from "./TicketsQuery.vue?vue&type=script&lang=js"
export * from "./TicketsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__